import {PureComponent} from 'react'
import {Card, CardImg, CardBody, CardTitle, CardSubtitle, CardText} from 'reactstrap'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import Date from '../../../../shared/components/Moment/Date.jsx'

import {generate} from '../../../routes.js'

import './ArticleCard.scss'

export default class ArticleCard extends PureComponent {
  static propTypes = {
    article: PropTypes.object,
  }

  static defaultProps = {
    article: null
  }

  generateLink = () => {
    return generate({
      name: 'blog-article',
      parameters: {
        slug: this.props.article.slug
      }
    })
  }

  render() {
    const img = this.props.article?.picture?.card ?? ''
    const title = this.props.article?.title ?? ''
    const excerpt = this.props.article?.excerpt ?? ''
    const date = this.props.article?.publishing_date ?? ''

    return (
      <li className="col-12 mx-auto mx-md-0 mb-md-4">
        <Link to={this.generateLink()}>
          <Card className="article-card d-flex align-items-center flex-column flex-xl-row">
            { img ? <CardImg className="d-block d-md-none d-xl-block" top src={img} alt={title}/> : '' }
            <div className="d-none d-md-flex d-xl-none align-items-center">
              <CardImg top src={img} alt={title}/>
              <div className="card-title-container pl-md-2">
                <CardTitle tag="h2">{title}</CardTitle>
                <CardSubtitle tag="p">
                  Publié le <Date format="dd/MM/yyyy" date={date}/>
                </CardSubtitle>
              </div>
            </div>
            <CardBody>
              <div className="d-block d-md-none d-xl-block">
                <CardTitle tag="h2">{title}</CardTitle>
                <CardSubtitle tag="p">
                  Publié le <Date format="dd/MM/yyyy" date={date}/>
                </CardSubtitle>
              </div>
              <CardText dangerouslySetInnerHTML={{__html: excerpt}} className="d-none d-md-block"/>
            </CardBody>
          </Card>
        </Link>
      </li>
    )
  }
}